import { render } from "./CadastrarModelos.vue?vue&type=template&id=455d6811"
import script from "./CadastrarModelos.vue?vue&type=script&lang=js"
export * from "./CadastrarModelos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__